var map = {
	"./download.png": "8cd3",
	"./download_android.png": "c097",
	"./language.png": "45bc",
	"./mc_c.png": "9c7a",
	"./mc_g.png": "56ae",
	"./mc_l.png": "60fb",
	"./mc_logo.png": "3634",
	"./mc_p.png": "9ab2",
	"./mc_w.png": "7736",
	"./mc_z.png": "41e7",
	"./mcapp.png": "db1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2d8";